import React, { useCallback, useEffect, useRef, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ButtonAction from '../Button.js/SaveButton';
import Loader from '../loader/loader';
import DatePickerValue from '../Input/DatePickerValue';
import moment from 'moment';
import ComboboxImage from '../Input/ComboboxImage';
import { toast } from 'react-toastify';
import { glb_sv, sendRequest, serviceList } from 'src/utils';

import { useDownloadExcel } from 'react-export-table-to-excel';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const ExportStaticstical_checking = ({ visible = false, setVisible, setTableData, tableData, tableRef }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [startDay, setstartDay] = useState(moment().subtract(1, 'month').format('YYYYMMDD'));
    const [toDay, settoDay] = useState(moment().format('YYYYMMDD'));
    const [cabinet, setcabinet] = useState({ cabinet_nm: t('all'), id: 0 });
    // const [tableData, setTableData] = useState([]);
    const [dataCabinet, setDataCabinet] = useState([]);
    const dataHis = useRef([
        // staff
        t('day_event'),
        t('name_staff'),
        t('username'),
        t('Email'),
        t('phone_supplier'),
        t('department'),
        t('group_staff'),
        // device
        t('name_device'),
        t('code_device'),
        t('supplier'),
        t('code_supplier'),
        t('persitional'),
        t('Email'),
        t('phone_supplier') + ' ' + t('supplier'),
        t('address_supplier') + ' ' + t('supplier'),
        t('producer'),
        t('department'),
        t('price') + ' ' + t('device'),
        t('status') + ' ' + t('device'),
        t('property'),
        t('name_cabinet'),
        t('code_cabinet'),
        t('name_drawer'),
        'ID' + ' ' + t('drawer'),
        t('row'),
        t('column'),
        t('status'),
        t('quantity_category'),
        t('note_'),
        t('group_staff'),
        // hết
        // t('name_staff'),
        // t('name_staff'),
        // t('name_staff'),
        // t('name_staff'),
    ]);
    const [flagActions, setflagActions] = useState(false);
    // const tableRef = useRef(null);
    const flagRef = useRef();
    const getRef = useRef(false);

    useEffect(() => {
        setTimeout(() => {
            getDataCabinet();
        }, 1000);
    }, []);
    useEffect(() => {
        setTimeout(() => {
            handleClick();
        }, 1000);
    }, [startDay, toDay, cabinet]);

    const getDataCabinet = useCallback(() => {
        if (getRef.current) return;
        getRef.current = true;
        const InVal = [];
        sendRequest(serviceList.getAllCabinetSp, InVal, getDataCabinetResult, true, timeOutFunctCabinet, 40000);
    }, []);

    const getDataCabinetResult = (reqInfoMap, message) => {
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataCabinet([
                { cabinet_nm: t('all'), id: 0 },
                ...message.proc_data.rows[0]?.o_1?.filter((ele) => ele.block_status === '1'),
            ]);
        }
    };
    const timeOutFunctCabinet = (reqInfo) => {
        getRef.current = false;
    };

    const handleClick = () => {
        if (flagRef.current) return;
        flagRef.current = true;
        setflagActions(true);
        const InVal = [startDay, toDay, cabinet?.id ? cabinet.id : 0];
        sendRequest(serviceList.getHisTransaction, InVal, historyResult, true, timeOutFunctHis, 40000);
    };

    const historyResult = useCallback(
        (reqInfoMap, message) => {
            flagRef.current = false;
            setflagActions(false);
            if ((message['proc_status']?.toString() || '0') === '0') {
                toast.error('Error: ' + message['proc_message']);
                return;
            } else {
                if (message.proc_data.rows[0]) {
                    const data = message.proc_data.rows[0]?.o_1;
                    setTableData(data);
                }
            }
        },
        [startDay, toDay, cabinet]
    );

    const timeOutFunctHis = (reqInfo) => {
        flagRef.current = false;
        setflagActions(false);
        toast.error(t('error.time_out'));
    };

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: t('history_cabinet'),
        sheet: t('history_cabinet'),
    });

    return (
        <BootstrapDialog
            // fullScreen
            open={visible}
            // onClose={() => setVisible(!visible)}
            aria-labelledby="customized-dialog-title"
        >
            <BootstrapDialogTitle
                onClose={() => {
                    setVisible(!visible);
                }}
                id="customized-dialog-title"
            >
                {t('history_cabinet')}
            </BootstrapDialogTitle>
            <Loader loading={flagActions} />
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <DatePickerValue label={t('start_day')} valueChange={startDay} getValue={setstartDay} />
                    </Grid>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <DatePickerValue label={t('to_day')} valueChange={toDay} getValue={settoDay} />
                    </Grid>{' '}
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <ComboboxImage
                            label={t('choose_cabinet')}
                            sizeCbb="medium"
                            getValue={setcabinet}
                            valueSelect={cabinet}
                            displayImage="img_cabinet"
                            selectOption={dataCabinet}
                            displayLabel="cabinet_nm"
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    onClick={() => {
                        setVisible(!visible);
                    }}
                    type={'cancel'}
                    title={t('cancel')}
                />
                <ButtonAction
                    onClick={() => {
                        setVisible(false);
                        tableData?.length > 0 ? onDownload() : toast.warning(t('not_data_report'));
                    }}
                    type={'export'}
                    title={t('export')}
                />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default ExportStaticstical_checking;
